// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/survey_view',['require','backbone','underscore','jquery','transform_image','raven','models/survey','models/participant','views/welcome','views/success','views/display_types/multiple','views/display_types/single','views/components/loader','views/components/theme_builder','sp/utilities/markdown_to_html','sp/utilities/get_hostname','sp/utilities/get_iframe_url','sp/utilities/preload_image','sp/utilities/is_object_id','sp/utilities/get_query_string_parameters','sp/ui/questions/question_forms/image','sp/ui/alert','sp/locals','sp/session','etc/definitions'],function(require) {
  var $, Alert, ImageQuestion, Loader, Multiple, Participant, Raven, Single, Success, Survey, SurveyView, ThemeBuilder, View, Welcome, _, definitions, getHostname, getIframeUrl, getQueryStringParameters, isObjectId, locals, markdownToHtml, preloadImage, session, transformImage;
  View = require('backbone').View;
  _ = require('underscore');
  $ = require('jquery');
  transformImage = require('transform_image');
  Raven = require('raven');
  Survey = require('models/survey');
  Participant = require('models/participant');
  Welcome = require('views/welcome');
  Success = require('views/success');
  Multiple = require('views/display_types/multiple');
  Single = require('views/display_types/single');
  Loader = require('views/components/loader');
  ThemeBuilder = require('views/components/theme_builder');
  markdownToHtml = require('sp/utilities/markdown_to_html');
  getHostname = require('sp/utilities/get_hostname');
  getIframeUrl = require('sp/utilities/get_iframe_url');
  preloadImage = require('sp/utilities/preload_image');
  isObjectId = require('sp/utilities/is_object_id');
  getQueryStringParameters = require('sp/utilities/get_query_string_parameters');
  ImageQuestion = require('sp/ui/questions/question_forms/image');
  Alert = require('sp/ui/alert');
  locals = require('sp/locals');
  session = require('sp/session');
  definitions = require('etc/definitions');
  return SurveyView = (function(superClass) {
    extend(SurveyView, superClass);

    function SurveyView() {
      this.windowMessageHandler = bind(this.windowMessageHandler, this);
      this.ajaxErrorHandler = bind(this.ajaxErrorHandler, this);
      this.windowUnloadHandler = bind(this.windowUnloadHandler, this);
      this.surveyCompleteHandler = bind(this.surveyCompleteHandler, this);
      this.surveyBeginHandler = bind(this.surveyBeginHandler, this);
      return SurveyView.__super__.constructor.apply(this, arguments);
    }


    /**
    		Constant used for defining participant data saved in local storage.
    
    		@property CACHE_PARTICIPANTS
    		@type String
    		@static
    		@const
     */

    SurveyView.CACHE_PARTICIPANTS = 'participants';


    /**
    		Constant used for wether the survey has already been taken by the
    		participant saved in local storage.
    
    		@property CACHE_SURVEY_COMPLETED
    		@type String
    		@static
    		@const
     */

    SurveyView.CACHE_SURVEY_COMPLETED = 'completed';


    /**
    		Event triggered when survey is ready.
    
    		@property READY_EVENT
    		@type String
    		@static
    		@const
     */

    SurveyView.READY_EVENT = 'ready';


    /**
    		Event triggered when there is an error.
    
    		@property ERROR_EVENT
    		@type String
    		@static
    		@const
     */

    SurveyView.ERROR_EVENT = 'error';


    /**
    		Event triggered when survey UI if fully rendered.
    
    		@property BEGIN_EVENT
    		@type String
    		@static
    		@const
     */

    SurveyView.BEGIN_EVENT = 'begin';


    /**
    		Event triggered when survey has been successfully submitted.
    
    		@property SUCCESS_EVENT
    		@type String
    		@static
    		@const
     */

    SurveyView.SUCCESS_EVENT = 'success';


    /**
    		Event triggered if they survey is not found or not active.
    
    		@property UNAVAILABLE_EVENT
    		@type String
    		@static
    		@const
     */

    SurveyView.UNAVAILABLE_EVENT = 'unavailable';


    /**
    		Event triggered if they survey has already been taken or invite hash
    		is invalid.
    
    		@property FORBIDDEN_EVENT
    		@type String
    		@static
    		@const
     */

    SurveyView.FORBIDDEN_EVENT = 'forbidden';


    /**
    		The DOM id of the survey
    
    		@property el
    		@type String
    		@default "#survey-container"
     */

    SurveyView.prototype.el = "#survey-container";


    /**
    		Flags whether the survey is a pro survey or not
    
    		@property pro
    		@type Boolean
    		@default false
     */

    SurveyView.prototype.pro = false;


    /**
    		Flags whether the survey is being viewed in preview mode/
    
    		@property preview
    		@type Boolean
    		@default false
     */

    SurveyView.prototype.preview = false;


    /**
    		Flags whether the survey participant has been disqualified and the answers
    		should not be submitted
    
    		@property disqualified
    		@type Boolean
    		@default false
     */

    SurveyView.prototype.disqualified = false;


    /**
    		The total number of questions in the survey
    
    		@property totalQuestions
    		@type number
    		@default 0
    		@readOnly
     */

    SurveyView.prototype.totalQuestions = 0;


    /**
    		The survey participant data
    
    		@property participant
    		@type Participant (Backbone.Model)
    		@default null
     */

    SurveyView.prototype.participant = null;


    /**
    		An ajax loader
    
    		@property loader
    		@type Loader
    		@default null
     */

    SurveyView.prototype.loader = null;


    /**
    		Browser is IE9 or not
    
    		@property unsupportedBrowser
    		@type Boolean
    		@default false
    		@deprecated
     */

    SurveyView.prototype.unsupportedBrowser = false;


    /**
    		Campaign invite id. Needed to submit surveys attached to Campaigns
    
    		@property inviteId
    		@type String
    		@default null
     */

    SurveyView.prototype.inviteId = null;

    SurveyView.prototype.initialize = function(options) {
      var data;
      SurveyView.__super__.initialize.call(this);
      data = options.data;
      Raven.config(GLOBALS.publicKeys.sentry, {
        environment: GLOBALS.env,
        release: GLOBALS.version,
        logger: 'javascript'
      }).install();
      Raven.setUserContext({
        id: _.get(data, ['user', '_id']),
        email: _.get(data, ['user', 'email'])
      });
      Raven.setExtraContext(data);
      $.ajaxSetup({
        cache: false,
        crossDomain: false,
        dataType: 'json'
      });
      _.mixin({
        markdownToHtml: markdownToHtml
      });
      if (data.language && data.language.definitions) {
        data.definitions = data.language.definitions;
      }
      if (data.user) {
        this.pro = (data.user.license && data.user.license.active) || (data.user.customer && data.user.customer.status);
      }
      if (data.invite) {
        this.inviteId = data.invite;
      }
      this.preview = data.preview;
      this.loader = new Loader();
      this.model = new Survey(data);
      this.initListeners();
      this.initParticipant();
      return this.preloadImages();
    };

    SurveyView.prototype.render = function() {
      this.unsupportedBrowser = $('html').is('.ie9');
      if (this.unsupportedBrowser) {
        this.renderBrowserWarning();
      }
      if (!isObjectId(this.model.get('_id'))) {
        return this.trigger(SurveyView.UNAVAILABLE_EVENT);
      }
      if (this.participant.get(SurveyView.CACHE_SURVEY_COMPLETED) && this.model.get('preventDuplicates')) {
        return this.trigger(SurveyView.FORBIDDEN_EVENT);
      }
      if (!this.model.get('active') && !this.preview) {
        return this.trigger(SurveyView.UNAVAILABLE_EVENT);
      }
      this.trigger(SurveyView.READY_EVENT);
      $('body').addClass(this.model.get('display').style);
      this.setHeaderLogo();
      return this.renderTheme((function(_this) {
        return function() {
          _this.loader.hide();
          $("#survey-header").css({
            opacity: 1
          });
          return _this.renderWelcome();
        };
      })(this));
    };

    SurveyView.prototype.initParticipant = function() {
      var audience, cache, queryStr;
      if (!this.preview) {
        cache = _.find(locals.get(SurveyView.CACHE_PARTICIPANTS), {
          survey: this.model.get('_id')
        });
      }
      this.participant = new Participant(cache);
      this.participant.set('survey', this.model.get('_id'));
      this.participant.set('referer', document.referrer);
      this.participant.set('userAgent', navigator.userAgent);
      queryStr = getQueryStringParameters();
      if (queryStr && queryStr.RID && queryStr.RID.length) {
        audience = {
          session: queryStr.RID
        };
        if ((queryStr.RISN != null) && !_.isNaN(queryStr.RISN)) {
          audience.survey = Number(queryStr.RISN);
        }
        this.participant.set('audience', audience);
        this.participant.set('referer', "https://audiences.surveyplanet.com?" + ($.param(audience)));
      }
      if (this.inviteId && this.inviteId.length) {
        return this.participant.set('invite', this.inviteId);
      }
    };

    SurveyView.prototype.preloadImages = function() {
      var images;
      images = [];
      if (this.model.get('welcome') && this.model.get('welcome').img && this.model.get('welcome').img.length) {
        images.push(this.model.get('welcome').img);
      }
      if (this.model.get('success') && this.model.get('success').img && this.model.get('success').img.length) {
        images.push(this.model.get('success').img);
      }
      this.model.get('questions').forEach(function(question) {
        var imgSize;
        if (question.type === 'image') {
          imgSize = (function() {
            switch (question.properties.size) {
              case 'large':
                return {
                  w: ImageQuestion.SIZE_LARGE[0],
                  h: ImageQuestion.SIZE_LARGE[1]
                };
              case 'small':
                return {
                  w: ImageQuestion.SIZE_SMALL[0],
                  h: ImageQuestion.SIZE_SMALL[1]
                };
              default:
                return {
                  w: ImageQuestion.SIZE_MEDIUM[0],
                  h: ImageQuestion.SIZE_MEDIUM[1]
                };
            }
          })();
          return question.properties.labels.forEach(function(label) {
            var img;
            if (label.image) {
              img = transformImage(label.image, {
                resize: {
                  width: imgSize.w,
                  height: imgSize.h,
                  fit: 'contain'
                }
              });
              if (img && img.length) {
                return images.push(img);
              }
            }
          });
        }
      });
      return preloadImage(images);
    };

    SurveyView.prototype.setHeaderLogo = function() {
      var $img, $logo, defaultLogo, img;
      defaultLogo = definitions.logo.light;
      $logo = $('#header-logo');
      $img = $logo.find('img');
      if (this.model.get('branding')) {
        if (this.model.get('branding').logo && this.model.get('branding').logo.length) {
          img = transformImage(this.model.get('branding').logo, {
            resize: {
              width: 150,
              height: 70,
              fit: 'inside'
            }
          }, false);
          $img.attr('src', img);
        } else {
          $img.attr('src', defaultLogo);
        }
        if (this.model.get('branding').url && this.model.get('branding').url.length) {
          return $logo.attr('href', this.model.get('branding').url);
        }
      } else {
        return $img.attr('src', defaultLogo);
      }
    };

    SurveyView.prototype.renderTheme = function(callback) {
      var themeBuilder;
      if (callback == null) {
        callback = function() {};
      }
      themeBuilder = new ThemeBuilder();
      themeBuilder.theme = this.model.get('theme');
      return themeBuilder.render(callback);
    };

    SurveyView.prototype.renderWelcome = function() {
      var welcome;
      welcome = new Welcome({
        model: this.model
      });
      welcome.definitions = this.model.get('definitions') || {};
      welcome.email = this.participant.get('email');
      welcome.on(Welcome.BEGIN_EVENT, this.surveyBeginHandler);
      this.$el.append(welcome.render());
      return welcome["in"]({
        animate: true
      }, (function(_this) {
        return function() {
          return _this.trigger(SurveyView.BEGIN_EVENT);
        };
      })(this));
    };

    SurveyView.prototype.renderBrowserWarning = function() {
      var alert;
      alert = new Alert();
      alert.type = "warning";
      alert.hideDelayTime = 0;
      alert.headline = "Unsupported Browser";
      alert.message = "Please note that SurveyPlanet no longer supports old versions of Internet Explorer.\nWe recommend upgrading to \n<a href=\"https://www.microsoft.com/en-us/windows/microsoft-edge\">Microsoft Edge</a>, \n<a href=\"https://chrome.google.com/\">Google Chrome</a>, or \n<a href=\"https://mozilla.org/firefox/\">Firefox</a>.\n<br><br>\nIf you're using a recent version of IE make sure you turn off\n<a target=\"_blank\" href=\"https://support.microsoft.com/en-us/help/17472/windows-internet-explorer-11-fix-site-display-problems-compatibility-v\"\n>Compatibility View</a>.";
      return alert.render();
    };

    SurveyView.prototype.initQuestions = function() {
      var displayType;
      displayType = (function() {
        switch (this.model.get('display').style) {
          case 'multiple':
            return new Multiple();
          case 'single':
            return new Single();
          default:
            return new Single();
        }
      }).call(this);
      displayType.model = this.model;
      displayType.participant = this.participant;
      displayType.hasBranches = _.some(this.model.get('questions'), function(question) {
        return (question.branches != null) && question.branches.length;
      });
      displayType.on('complete', this.surveyCompleteHandler);
      return this.$el.append(displayType.render());
    };

    SurveyView.prototype.getSuccessRedirect = function(url, newParams, appendCurrentQueryParams) {
      var currentParams, params, urlParams;
      if (appendCurrentQueryParams == null) {
        appendCurrentQueryParams = false;
      }
      currentParams = {};
      if (appendCurrentQueryParams) {
        currentParams = getQueryStringParameters();
      }
      urlParams = getQueryStringParameters(url || '') || {};
      params = _.assign(urlParams, newParams, currentParams);
      if (!_.isEmpty(params)) {
        url = url.split(/[?#]/)[0];
        url += "?";
        url += $.param(params);
      }
      return url;
    };

    SurveyView.prototype.renderSuccess = function() {
      var audience, data, delay, initSuccess, queryParams, redirect, status;
      this.trigger(SurveyView.SUCCESS_EVENT);
      if (!this.preview) {
        this.destroyListeners();
      }
      this.loader.hide();
      data = this.model.get('success');
      queryParams = {
        sid: this.model.get('_id'),
        pid: this.participant.get('_id')
      };
      redirect = this.getSuccessRedirect(GLOBALS.uris.front + "/success", queryParams);
      audience = this.participant.get('audience');
      if (audience && audience.session && audience.session.length) {
        status = definitions.audienceStatus.complete;
        if ((audience.status != null) && audience.status > status) {
          status = audience.status;
        }
        queryParams = {
          status: status,
          session: audience.session
        };
        if (audience.survey) {
          queryParams.survey = audience.survey;
        }
        redirect = this.getSuccessRedirect('/success/audience', queryParams);
        return window.location.href = redirect;
      } else if (this.pro || this.preview) {
        initSuccess = (function(_this) {
          return function() {
            var success;
            success = new Success({
              model: _this.model
            });
            success.definitions = _this.model.get('definitions') || {};
            _this.$el.append(success.render());
            return success["in"]({
              animate: true
            });
          };
        })(this);
        if (data && data.url && data.url.length) {
          redirect = this.getSuccessRedirect(data.url, queryParams, true);
          if (_.toNumber(data.delay) > 0) {
            initSuccess();
            delay = (data.delay * 1000) + 500;
            return setTimeout((function(_this) {
              return function() {
                return window.location.href = redirect;
              };
            })(this), delay);
          } else {
            return window.location.href = redirect;
          }
        } else {
          return initSuccess();
        }
      } else {
        session.set('success-msg', data.msg);
        return window.location.href = redirect;
      }
    };

    SurveyView.prototype.clearParticipantCache = function() {
      var index, participant, participants;
      if (this.model) {
        participants = locals.get(SurveyView.CACHE_PARTICIPANTS, []);
        participant = {};
        participant.survey = this.model.get('_id');
        participant[SurveyView.CACHE_SURVEY_COMPLETED] = true;
        index = _.findIndex(participants, {
          survey: this.model.get('_id')
        });
        if (index >= 0) {
          participants.splice(index, 1, participant);
        } else {
          participants.push(participant);
        }
        return locals.set(SurveyView.CACHE_PARTICIPANTS, participants);
      }
    };

    SurveyView.prototype.cacheParticipant = function() {
      var cache, participants;
      if (this.model && this.participant) {
        cache = locals.get(SurveyView.CACHE_PARTICIPANTS, []);
        participants = _.reject(cache, {
          survey: this.model.get('_id')
        });
        participants.push(this.participant.toJSON());
        return locals.set(SurveyView.CACHE_PARTICIPANTS, participants);
      }
    };

    SurveyView.prototype.saveParticipant = function() {
      var participant;
      this.loader.show();
      if (!this.preview && !this.participant.disqualified) {
        this.participant.get('time').end = new Date();
        participant = this.participant.toJSON();
        delete participant._id;
        return $.ajax({
          url: "/success",
          type: "POST",
          dataType: 'json',
          data: participant
        }).done((function(_this) {
          return function(result) {
            if (result.status === 200) {
              _this.clearParticipantCache();
              _this.participant = new Participant(result.data);
              return _this.renderSuccess();
            }
          };
        })(this)).fail((function(_this) {
          return function(err) {
            return _this.cacheParticipant();
          };
        })(this));
      } else {
        return this.renderSuccess();
      }
    };

    SurveyView.prototype.destroyListeners = function() {
      $(window).off('beforeunload', this.windowUnloadHandler);
      return $(window).off('message', this.windowMessageHandler);
    };

    SurveyView.prototype.initListeners = function() {
      $(document).ajaxError(this.ajaxErrorHandler);
      $(window).on('beforeunload', this.windowUnloadHandler);
      return $(window).on('message', this.windowMessageHandler);
    };

    SurveyView.prototype.surveyBeginHandler = function(welcome) {
      if (welcome instanceof Welcome) {
        this.participant.set('email', welcome.email);
        if (!_.isDate(this.participant.get('time').start)) {
          this.participant.get('time').start = new Date();
        }
        welcome.out({
          animate: true,
          destroyOnComplete: true
        }, function() {
          return $('body').scrollTop(0);
        });
        return this.initQuestions();
      }
    };

    SurveyView.prototype.surveyCompleteHandler = function(e) {
      return this.saveParticipant();
    };

    SurveyView.prototype.windowUnloadHandler = function(e) {
      return this.cacheParticipant();
    };

    SurveyView.prototype.ajaxErrorHandler = function(event, request, settings, error) {
      var alert, contactLink;
      this.loader.hide();
      Raven.captureMessage(error || request.statusText, {
        extra: {
          type: settings.type,
          url: settings.url,
          status: request.status,
          error: error || request.statusText,
          response: request.responseText && request.responseText.length ? request.responseText.substring(0, 100) : void 0
        }
      });
      this.trigger(SurveyView.ERROR_EVENT, request.status);
      this.destroyListeners();
      if (request.status !== 200) {
        contactLink = "<a href='https://surveyplanet.com/contact' target='_blank'>contact us</a>";
        alert = new Alert();
        alert.hideDelayTime = 0;
        alert.type = "error";
        switch (request.status) {
          case 413:
            alert.headline = "Request Too Large";
            alert.message = "Sorry, we're unable to complete this request because \nit is too large. Refresh the page and try to pare \ndown some of your responses or " + contactLink + ", we're \nhappy to help.";
            break;
          case 404:
            alert.headline = "Not Found";
            alert.message = "Sorry, we're unable to find this survey; \ncheck the survey url and try it again. If you're sure \nit's correct please " + contactLink + ", \nwe're happy to help.";
            break;
          case 400:
            alert.headline = "Invalid Request";
            alert.message = "Required parameters are missing or invalid. If you \nfeel you've received this message in error please\n" + contactLink + ", we're happy to help.";
            break;
          default:
            alert.headline = "Unexpected Error";
            alert.message = "Please refresh the page and try again; if that \ndoesn't help " + contactLink + ", we're happy to help.";
        }
        return alert.render();
      }
    };

    SurveyView.prototype.windowMessageHandler = function(e) {
      var data;
      data = e.originalEvent.data || {};
      if (_.isString(data)) {
        try {
          data = JSON.parse(data);
        } catch (error1) {}
      }
      if (this.preview && data) {
        if (data.hasOwnProperty('theme')) {
          this.model.set('theme', data.theme || {});
          return this.renderTheme();
        }
      }
    };

    return SurveyView;

  })(View);
});

